import React from 'react';
import Header from '../components/Header';
import Commitment from '../components/Commitment';
import Footer from '../components/Footer';

const CommitmentPage = () => {
  return (
    <div className="App">
      <Header />
      <main><Commitment /></main>
      <Footer />
    </div>
  );
};

export default CommitmentPage;
